const defaultCrudConfig = {
    endpoint: 'valuesets',
    primaryKey: 'valueSetId',
    globalSearchFieldName: 'text',
    globalSearchQueryClass: 'ByGeneralProperties',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        // fetchBy: {
        //     method: 'get',
        //     returnType: 'Array',
        //     service: 'cds',
        //     args: ['type', 'queryClass', 'arg'],
        //     query: {
        //         filter: '#@type@#=#@arg@#',
        //         property: 'queryClass=#@queryClass@#'
        //     },
        // },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['valueSetId'],
            query: {
                filter: 'valueSetId=#@valueSetId@#',
                property: 'queryClass=PrimaryKey'
            }
        },
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['valueSetId', 'vsDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'cds',
            args: ['valueSetId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds',
            args: ['valueSetDoc']
        }
    }
};

export default defaultCrudConfig;
